// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination, Autoplay } from "swiper";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";
// import "swiper/css/autoplay";
// // import { useSpring, animated } from "react-spring";
// // import { useInView } from "react-intersection-observer";
// import "./hero.css";

// import part1 from "../../img/C1-1.png";
// import part2 from "../../img/des_sec/hero_cont_1.svg";
// import part3 from "../../img/big 1-4.png";
// import summit from "../../img/Summit.png";
// import { LazyLoadComponent } from 'react-lazy-load-image-component';

// function Hero({ openModal }) {
//   // const [ref, inView] = useInView({ threshold: 0.01 });

//   // const props = useSpring({
//   //   to: {
//   //     opacity: inView ? 1 : 0,
//   //     transform: inView ? "translateX(0)" : "translateX(-20%)",
//   //   },
//   //   config: { duration: 1000 },
//   // });

//   return (
//     // <LazyLoadComponent>
//     <div 
//     id="Home" 
//     className="main-donation-d2" 
//     // style={{ backgroundImage: 'url("../../img/des_sec/wiki_2_bg.svg")' }}
//   >
//       <div className="achievementsMain-d2" id="Feats">       
//             <div className="hero-content">
//               <div className="achievementLeft-d2">
//                 <div className="statusContainer2-d2">
//                   {/* <div className="summit">
//                     <img src={summit} alt="summit" />
//                   </div> */}
//                   <div className="statusTexts-d2">
//                     <div className="header-wrap">
//                     <img src={part2} className="hero-cont" alt="World map" />
//                       <h2 className="statusHeader-d2">
//                       Where <span className="bold-header">Workforce Management</span> meets <span className="bold-header">Automation</span> and <span className="bold-header">Compliance</span>
//                       </h2>
//                     </div>
//                     <p className="statusPara-d2">
//                     This is the all-in-one solution for effortless contract labour management digital onboarding, real-time background checks, and proactive compliance alerts.
//                     </p>
//                   </div>
//                   <div className="button-row">
//                     <button onClick={openModal} className="award-button-h">
//                       Book Demo
//                     </button>
//                     <button
//                       onClick={() => (window.location.href = "/vyn")}
//                       className="outlined-button"
//                     >
//                       Know more
//                     </button>
//                   </div>
//                 </div>
//               </div>
//               {/* <div className="world-map">
//                 <img src={part2} alt="World map" />
//               </div> */}
//             </div>
//       </div>
//     </div>
//     // </LazyLoadComponent>
//   );
// }

// export default Hero;

import React, { useRef, useEffect, useState } from "react";
import { useSpring, animated } from 'react-spring';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "./hero.css";

import part1 from "../../img/C1-1.png";
import part2 from "../../img/des_sec/hero_cont_1.svg";
import part3 from "../../img/big 1-4.png";
import summit from "../../img/Summit.png";
import { LazyLoadComponent } from 'react-lazy-load-image-component';

function Hero({ openModal }) {
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  // Animation for hero image
  const imageAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(15px) scale(0.98)',
    config: {
      tension: 160,
      friction: 30,
      mass: 1
    },
    delay: inView ? 100 : 0
  });

  // Animation for main heading
  const headingAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: {
      tension: 180,
      friction: 35,
      mass: 1
    },
    delay: inView ? 300 : 0
  });

  // Animation for paragraph
  const paragraphAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(15px)',
    config: {
      tension: 160,
      friction: 30,
      mass: 1
    },
    delay: inView ? 500 : 0
  });

  // Animation for buttons with stagger
  const button1Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(10px) scale(0.98)',
    config: {
      tension: 150,
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 700 : 0
  });

  const button2Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(10px) scale(0.98)',
    config: {
      tension: 150,
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 850 : 0
  });

  return (
    <div
      id="Home"
      className="main-donation-d2"
      ref={containerRef}
    >
      <div className="achievementsMain-d2" id="Feats">
        <div className="hero-content">
          <div className="achievementLeft-d2">
            <div className="statusContainer2-d2">
              <div className="statusTexts-d2">
                <div className="header-wrap">
                  <animated.img
                    src={part2}
                    className="hero-cont"
                    alt="World map"
                    style={{
                      ...imageAnimation,
                      position: 'relative',
                      zIndex: 1
                    }}
                  />
                  <animated.h2
                    className="statusHeader-d2"
                    style={{
                      ...headingAnimation,
                      position: 'relative',
                      zIndex: 1
                    }}
                  >
                    Where <span className="bold-header">Workforce Management</span> and <span className="bold-header">Compliance</span> are powered by <span className="bold-header">AI</span>
                  </animated.h2>
                </div>
                <animated.p
                  className="statusPara-d2"
                  style={{
                    ...paragraphAnimation,
                    position: 'relative',
                    zIndex: 1
                  }}
                >
                  An all-in-one platform for effortless contract labour management with digital onboarding, real-time background verification, AI-driven automation, and proactive compliance monitoring.
                </animated.p>
              </div>
              <div className="button-row">
                <animated.button
                  onClick={openModal}
                  className="award-button-h"
                  style={{
                    ...button1Animation,
                    position: 'relative',
                    zIndex: 1
                  }}
                >
                  Book Demo
                </animated.button>
                <animated.button
                  onClick={() => (window.location.href = "/vyn")}
                  className="outlined-button"
                  style={{
                    ...button2Animation,
                    position: 'relative',
                    zIndex: 1
                  }}
                >
                  Know more
                </animated.button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
